/**
 * <pre>
 * Service container.
 *
 * Summary of responsibilities:
 *
 *  - provides abstraction layer for access to services.
 * </pre>
 *
 * @author Various
 * @namespace Common.Services.ServiceContainer
 */
const ServiceContainer = (function() {

	'use strict';

	// Services.
	var services = [];

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	/**
	 * Init.
	 *
	 */
	const init = () => {

	};

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// Mutator/accessor Methods.

	// Add a service
	const addService = (serviceKey, service) => {

		// Check service with matching key has not already been added.
		if(!services[serviceKey]) {
			services[serviceKey] = service;
		}
	};

	// Get a service
	const getService = (serviceKey) => {

		let service;

		// If service with requested key exists.
		if(services[serviceKey]) {
			service = services[serviceKey];
		}

		return service;
	};

	// Expose scoped properties.
	return {

		init: 				init,

		addService: 		addService,
		getService: 		getService
	}

}());

export default ServiceContainer;